<script setup lang="ts">
import type { LoyaltyReward } from '@/types/types'

withDefaults(
  defineProps<{
    reward: LoyaltyReward
    isRewardSelected: boolean
    buttonShown: ('edit' | 'clear' | 'change')[]
    rewardItemClass?: string
  }>(),
  {
    isRewardSelected: false
  }
)

const emit = defineEmits<{
  (e: 'clearReward', rewardId: number)
  (e: 'editReward', rewardId: number)
  (e: 'changeReward', rewardId: number)
}>()
</script>

<template>
  <div
    :class="[
      'flex w-full flex-col items-center justify-between rounded-xl border bg-white p-3 sm:flex-row',
      rewardItemClass
    ]"
  >
    <div class="flex min-w-14 flex-row items-center sm:mr-4">
      <img :src="reward.pictureUrl" class="h-8 w-14 rounded-md object-cover object-center" />
    </div>

    <div class="flex flex-1 flex-col items-center sm:mr-4">
      <div class="flex text-left w-full flex-row text-sm text-foreground">
        {{ reward.name }}
      </div>
      <div class="flex w-full flex-row">
        <div class="flex flex-row text-xs text-muted-foreground">
          <BaseIcon
            v-if="reward.rewardType.slug === 'free_product'"
            name="HeroGiftIconSolid"
            class="mr-1 h-3.5 w-3.5"
          />
          <BaseIcon
            v-if="reward.rewardType.slug === 'voucher_discount_percent'"
            name="HeroReceiptPercentIconSolid"
            class="mr-1 h-3.5 w-3.5"
          />
          <BaseIcon
            v-if="reward.rewardType.slug === 'voucher_discount_amount'"
            name="HeroReceiptRefundIconSolid"
            class="mr-1 h-3.5 w-3.5"
          />
          <BaseIcon
            v-if="reward.rewardType.slug === 'voucher_x_for_y'"
            name="HeroShoppingBagIconOutline"
            class="mr-1 h-3.5 w-3.5"
          />
          {{ reward.rewardType.name }}
        </div>
      </div>
    </div>

    <div>
      <Button
        v-if="buttonShown.includes('edit')"
        variant="outline"
        class="h-8 px-2! sm:ml-3"
        @click="emit('editReward', reward.id)"
      >
        <BaseIcon name="HeroPencilSquareIconSolid" class="h-4 w-4 text-foreground" />
      </Button>

      <Button
        v-if="buttonShown.includes('change')"
        variant="outline"
        class="h-8 px-2! sm:ml-3"
        @click="emit('changeReward', reward.id)"
      >
        <BaseIcon name="HeroArrowPathIconSolid" class="h-4 w-4 text-foreground" />
      </Button>
      <Button
        v-if="buttonShown.includes('clear')"
        variant="outline"
        class="h-8 px-2! sm:ml-3"
        @click="emit('clearReward', reward.id)"
      >
        <BaseIcon name="HeroTrashIconSolid" class="h-4 w-4 text-foreground" />
      </Button>
    </div>
  </div>
</template>
